export default __webpack_public_path__ + "3c5d62643366b67d7cb1861c1a4f664e.svg";